var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from 'react';
import { apiUpdateClientHotlineRequestInterviewBulkCancel } from '@/actions/ClientHotlineRequestInterviewActions';
import { notify, notifyError } from '@/helpers/action';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { sleep } from '@/utils/async/sleep';
/**
 * ホットライン 一括キャンセル機能の hook
 */
export const useHotlineClientBulkCancel = (options) => {
    const { dispatch, id, onSubmitCallback, unmountRef } = options;
    // 一括キャンセル対象の ID
    const [cancelTargetIds, setCancelTargetIds] = useState([]);
    /**
     * 一括キャンセル対象の ID を更新する
     */
    const updateCancelTargetIds = useCallback((requestId) => {
        setCancelTargetIds((prev) => prev.includes(requestId)
            ? prev.filter((targetId) => targetId !== requestId)
            : [...prev, requestId]);
    }, []);
    /**
     * 送信処理
     */
    const onSubmit = useCallback((formValue, afterCallback) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield wrapDispatch(dispatch, apiUpdateClientHotlineRequestInterviewBulkCancel({
                json: {
                    cancel_reason: formValue.cancelReason,
                    hotline_request_ids: cancelTargetIds,
                },
                path: { id },
            }, {}));
            yield (onSubmitCallback === null || onSubmitCallback === void 0 ? void 0 : onSubmitCallback());
            if (unmountRef.current)
                return;
            // 一括キャンセル対象の ID をクリア
            setCancelTargetIds([]);
            // モーダルを閉じる
            afterCallback === null || afterCallback === void 0 ? void 0 : afterCallback();
            // モーダル閉じ終わるまで待機
            yield sleep(400);
            if (unmountRef.current)
                return;
            // 成功メッセージを表示
            notify('一括キャンセルしました');
        }
        catch (error) {
            if (unmountRef.current)
                return;
            // モーダルを閉じる
            afterCallback === null || afterCallback === void 0 ? void 0 : afterCallback();
            // モーダル閉じ終わるまで待機
            yield sleep(400);
            if (unmountRef.current)
                return;
            // エラーメッセージを表示
            notifyError();
        }
    }), [cancelTargetIds, dispatch, id, onSubmitCallback, unmountRef]);
    return {
        cancelTargetIds,
        onSubmitBulkCancel: onSubmit,
        updateCancelTargetIds,
    };
};
